import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
//import {otpValidationPopupContent, customerTypeEnum, lobbyTabsEnum, searchParametersEnum, pages} from './cellcomAbroadVariables';

export function gaSelectedCompanyIsNotAllowed() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED.eventParams
  );
}

export function gaNotAllowedCallBackClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED_CALLBACK_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED_CALLBACK_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECTED_COMPANY_NOT_ALLOWED_CALLBACK_CLICK.eventParams
  );
}

export function gaSelectCompanyComponentView() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_VIEW.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_VIEW.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_VIEW.eventParams
  );
}
export function gaSelectingCampaign() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_SELECT_BOX_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_SELECT_BOX_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_SELECT_BOX_CLICK.eventParams
  );
}
export function gaSelectingCampaignContinueClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_CONTINUE_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_CONTINUE_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_CONTINUE_BUTTON_CLICK.eventParams
  );
}
export function gaOnlyOneAndNotAllowed() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_ONLY_ONE_AND_NOT_ALLOWED.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_ONLY_ONE_AND_NOT_ALLOWED.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_ONLY_ONE_AND_NOT_ALLOWED.eventParams
  );
}
export function gaNotAllowedForDefaultCallBackClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_ONLY_ONE_AND_NOT_ALLOWED_CALL_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_ONLY_ONE_AND_NOT_ALLOWED_CALL_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_ONLY_ONE_AND_NOT_ALLOWED_CALL_BUTTON_CLICK.eventParams
  );
}

export function gaSelectCompanyFinishButtonClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_FINISH_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_FINISH_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_COMPANY_COMPONENT_FINISH_BUTTON_CLICK.eventParams
  );
}
export function gaSelectAccountComponentView() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW.eventParams
  );
}
export function gaSelectAccountViewOnlyButtonClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW_ONLY_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW_ONLY_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VIEW_ONLY_BUTTON_CLICK.eventParams
  );
}

export function gaSelectAccountContinueButtonClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_CONTINUE_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_CONTINUE_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_CONTINUE_BUTTON_CLICK.eventParams
  );
}
export function gaSelectAccountErrorMessage(error) {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_ERROR_MESSAGE.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_ERROR_MESSAGE.eventType,
    error
  );
}
export function gaPricePlanVoiceExistsButtonClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP_BUTTON_CLICK.eventParams
  );
}
export function gaCustomerGoldClassButtonClick() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP_BUTTON_CLICK.eventParams
  );
}
